/**
 * 给一段文字派生一个稳定的颜色 token,同样的文字永远是同样的色。
 *
 * 取 djb2 hash 的低 16 位 → hue (0-359),其它两个分量固定到一个柔和、
 * 高对比度的浅色块。亮/暗主题用不同 lightness 但同 hue,保证视觉一致。
 */

function hash(text: string): number {
  let h = 5381;
  const s = text.trim().toLowerCase();
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export type TagColor = {
  bg: string;
  border: string;
  fg: string;
};

export function tagColor(text: string): TagColor {
  const hue = hash(text) % 360;
  // 亮色背景, 边框稍深, 文字深色, WCAG AA 对比度可控。
  return {
    bg: `hsl(${hue} 85% 92%)`,
    border: `hsl(${hue} 70% 78%)`,
    fg: `hsl(${hue} 60% 25%)`,
  };
}
